<template>
  <div class="pd-top-15">
    <page-layout
      :breadcrumbs="[
        {
          text: this.$t('navDrawer.home').toUpperCase(),
          disabled: false,
          to: {name: 'home'},
          exact: true
        },
        {
          text: localization.title.toUpperCase(),
          disabled: true
        }
      ]"
    >
      <o-main-progress v-if="loading" />
      <v-row  v-else wrap no-gutters class="py-2">
        <v-col cols="12">
          <v-tabs v-model="seccionActual" id="seccionActual" grow color="primary"
            background-color="transparent" class="transparentTabs">
            <v-tab v-for="(item, index) in items" :key="index + '-tab'">
              <v-row justify="center" align="center">
                {{item.name}}
              </v-row>
            </v-tab>
            <v-tab-item v-for="(item, index) in items" :key="index + '-tab-item'">
              <v-container fluid>
                <component :is="item.tipo" />
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
    </page-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import relacionIncidencias from './relacionIncidencias'
import incidenciasVencidas from './incidenciasVencidas'
import estadisticasIncidencias from './estadisticasIncidencias'
import informeSoporteDocumental from './informeSoporteDocumental'
import encuestas from './encuestas.vue'
import relacionInteracciones from './relacionInteracciones'

export default {
  components: {
    relacionIncidencias,
    incidenciasVencidas,
    estadisticasIncidencias,
    informeSoporteDocumental,
    relacionInteracciones,
    encuestas
  },
  data () {
    return {
      seccionActual: 0,
      loading: false
    }
  },
  async created () {
    const loader = this.$loading.show({
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false
    })
    try {
      this.loading = true
      await Promise.all([
        this.getStatusTypes(),
        this.getVisitTypes(),
        this.getPropertiesDevelopment(),
        this.getOficios(),
        this.getSuboficios(),
        this.getComplaintTypes(),
        this.getOrderTypes(),
        this.getProviders(),
        this.getClientesEspeciales(),
        this.getLocalizaciones(),
        this.getUrgencias(),
        this.getClientes()
      ])
    } catch (error) {
      this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
    }
    loader.hide()
    this.loading = false
  },
  computed: {
    ...mapGetters({
      configuracion: 'configuracion/getConfiguracion',
      idubapi: 'login/idubapi'
    }),
    localization () {
      return this.$t('sectionInformes')
    },
    items () {
      
      const usuario = JSON.parse(localStorage.getItem('usuario'))
      const rolUsuario = usuario.roles[0]

      let encuesta = this.configuracion.PV_ACTIVAR_ENCUESTA
      let permisosExtraProveedor = this.configuracion.PV_PERMISOS_EXTRA_PROVEEDOR

      let itemEncuesta = []

      if(encuesta) {
        itemEncuesta.push({
          tipo: 'encuestas',
          name: this.localization.tabsTitles.encuestas
        })
      }

      let items = [
        {
          tipo: 'relacionIncidencias',
          name: this.localization.tabsTitles.relacionIncidencias
        },
        {
          tipo: 'incidenciasVencidas',
          name: this.localization.tabsTitles.incidenciasVencidas
        },
        {
          tipo: 'estadisticasIncidencias',
          name: this.localization.tabsTitles.estadisticas
        },
        {
          tipo: 'informeSoporteDocumental',
          name: this.localization.tabsTitles.informeSoporteDocumental
        },
        {
          tipo: 'relacionInteracciones',
          name: this.localization.tabsTitles.relacionInteracciones
        },
        ...itemEncuesta
      ]

      if ( rolUsuario == 'PV_PROVEEDOR' && this.configuracion.permitirAsignarPromocionesProveedor ) {
        items = [
          {
            tipo: 'relacionIncidencias',
            name: this.localization.tabsTitles.relacionIncidencias
          }
        ]
      }
      
      if ( rolUsuario == 'PV_PROVEEDOR' && permisosExtraProveedor && !this.accesoTodasIncidencias() ) {
        items = [
          {
            tipo: 'relacionIncidencias',
            name: this.localization.tabsTitles.relacionIncidencias
          },
          {
            tipo: 'informeSoporteDocumental',
            name: this.localization.tabsTitles.informeSoporteDocumental
          }
        ]
      }

      return items
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getStatusTypes: 'incidencias/getStatusTypes',
      getVisitTypes: 'incidencias/getVisitTypes',
      getPropertiesDevelopment: 'incidencias/getPropertiesDevelopment',
      getOficios: 'incidencias/getOficios',
      getSuboficios: 'incidencias/getSuboficios',
      getComplaintTypes: 'incidencias/getComplaintTypes',
      getOrderTypes: 'incidencias/getOrderTypes',
      getProviders: 'incidencias/getProviders',
      getClientesEspeciales: 'incidencias/getClientesEspeciales',
      getUrgencias: 'incidencias/getUrgencias',
      getLocalizaciones: 'incidencias/getAllRoomPropertyTypes',
      getClientes: 'incidencias/getClientes'
    }),
    accesoTodasIncidencias() {
      return this.idubapi.PERMISOS_ROL_PROVEEDOR_WEB.ACCESO_TODAS_INCIDENCIAS == 1 ? true : false
    },
  }
}
</script>
